import {Component, OnInit} from '@angular/core';
import {ComponentHelper, FormBaseComponent, ValidationPattern, ValidatorService} from '@utils-lib';
import {AppNameEnum, Betriebstaette, LohnsteuerAngaben} from '@nachdigal';
import {FormBuilder} from '@angular/forms';
import {DatevMessageService} from '@datev/ngx-ui-components';
import {TranslateService} from '@ngx-translate/core';
import {isEmpty} from 'lodash';
import {ActivatedRoute} from '@angular/router';

@Component({
    selector: 'common-ui-lohnsteuer',
    templateUrl: './lohnsteuer.component.html',
    styleUrls: ['./lohnsteuer.component.scss']
})
export class LohnsteuerComponent extends FormBaseComponent<LohnsteuerAngaben> implements OnInit {

    public betriebstaetten: Array<Betriebstaette> = [];

    public showHinweis = false;
    public zahlGesamt: string;
    public zahlFamilie: string;
    public zahlGeringfuegig: string;
    public arbeitnehmerTitel = '';


    constructor(private readonly formBuilder: FormBuilder,
                private readonly validatorService: ValidatorService,
                protected readonly messageService: DatevMessageService,
                protected readonly translateService: TranslateService,
                protected readonly activatedRoute: ActivatedRoute) {
        super(messageService);
    }

    public ngOnInit(): void {
        super.ngOnInit();
        const appEnum = ComponentHelper.getAppEnum(this.activatedRoute.snapshot);

        this.zahlGesamt = this.translateService.instant('COMMON_UI.FRAGEBOGEN.LOHNSTEUER.ZAHL_ARBEITNEHMER.ZAHL_AN_INSGESAMT');
        this.zahlFamilie = this.translateService.instant('COMMON_UI.FRAGEBOGEN.LOHNSTEUER.ZAHL_ARBEITNEHMER.DAVON_FAMILIENANGEHOERIGE');
        this.zahlGeringfuegig = this.translateService.instant(
            'COMMON_UI.FRAGEBOGEN.LOHNSTEUER.ZAHL_ARBEITNEHMER.DAVON_GERINGFUEGIG_BESCHAEFTIGTE'
        );

        if (appEnum === AppNameEnum.FragebogenKapG || appEnum === AppNameEnum.FragebogenKapGAus) {
            this.showHinweis = true;
            this.zahlGesamt = this.translateService.instant('COMMON_UI.FRAGEBOGEN.LOHNSTEUER.ZAHL_ARBEITNEHMER_KAPG.ZAHL_AN_INSGESAMT');
            this.zahlFamilie = this.translateService
                .instant('COMMON_UI.FRAGEBOGEN.LOHNSTEUER.ZAHL_ARBEITNEHMER_KAPG.GLEICHZEITIG_GESELLSCHAFTER');
            this.zahlGeringfuegig = this.translateService
                .instant('COMMON_UI.FRAGEBOGEN.LOHNSTEUER.ZAHL_ARBEITNEHMER_KAPG.DAVON_GERINGFUEGIG_BESCHAEFTIGTE');
        }
        this.arbeitnehmerTitel = appEnum === AppNameEnum.FragebogenKapGAus
            ? 'COMMON_UI.FRAGEBOGEN.LOHNSTEUER.ZAHL_BUNDESREPUBLIK_ARBEITNEHMER.TITEL'
            : 'COMMON_UI.FRAGEBOGEN.LOHNSTEUER.ZAHL_ARBEITNEHMER.TITEL';
    }

    protected createForm(): void {
        const ganzzahlPositivInstant = 'COMMON_UI.VALIDATION.GANZZAHL_POSITIV';
        this.form = this.formBuilder.group({
            arbeitnehmer: [
                this.data.arbeitnehmer, [
                    this.validatorService.maxLength(6),
                    this.validatorService.pattern(ValidationPattern.POSITIV_INTEGER,
                        this.translateService.instant(ganzzahlPositivInstant)),
                    this.validatorService.conditionTrue(this.isArbeitnehmerSummeValide.bind(this),
                        this.translateService.instant('COMMON_UI.VALIDATION.ARBEITNEHMER_SUMME_VALIDE'))
                ]],
            familienangehoerige: [
                this.data.familienangehoerige, [
                    this.validatorService.maxLength(6),
                    this.validatorService.pattern(ValidationPattern.POSITIV_INTEGER,
                        this.translateService.instant(ganzzahlPositivInstant))
                ]],
            geringfuegigBeschaeftigte: [
                this.data.geringfuegigBeschaeftigte, [
                    this.validatorService.maxLength(6),
                    this.validatorService.pattern(ValidationPattern.POSITIV_INTEGER,
                        this.translateService.instant(ganzzahlPositivInstant))
                ]]
        });
    }

    private isArbeitnehmerSummeValide(): boolean {

        if (isNaN(+this.data.arbeitnehmer) || +this.data.arbeitnehmer < 0) {
            return true;
        }

        let familienangehoerige = 0;
        if (!isEmpty(this.data.familienangehoerige) && !isNaN(+this.data.familienangehoerige)) {
            familienangehoerige = +this.data.familienangehoerige;
        }

        let geringfuegigBeschaeftigte = 0;
        if (!isEmpty(this.data.geringfuegigBeschaeftigte) && !isNaN(+this.data.geringfuegigBeschaeftigte)) {
            geringfuegigBeschaeftigte = +this.data.geringfuegigBeschaeftigte;
        }

        return familienangehoerige + geringfuegigBeschaeftigte <= +this.data.arbeitnehmer;
    }

}
